<template>
    <section class="page-section" id="links">
        <div class="py-5">
            <div class="container">
                <div class="row text-center">
                    <div class="col-md-3" v-for="(obj, key) in linksJSON" :key=key>
                        <a :href="obj.link" target="_blank"><img class="img-fluid d-block mx-auto" :src="obj.img" :alt="obj.title" /></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: () => ({
        linksJSON: [
            {
                img: require('../assets/img/links/rickenbach-logo.jpg'),
                link: 'https://www.rickenbach-bl.ch/',
                title: 'Rickenbach'
            },
            {
                img: require('../assets/img/links/takeoff.jpg'),
                link: 'http://www.duotakeoff.ch/',
                title: 'Take Off'
            },
            {
                img: require('../assets/img/links/fgr.jpg'),
                link: 'https://www.fasnachtsgesellschaft.ch/',
                title: 'Fasnachtsgesellschaft Wüehlmüüs Rickenbach'
            },
            {
                img: require('../assets/img/links/hrosenau.jpg'),
                link: 'https://www.hofbeck-rosenau.com/',
                title: 'HOFBÄCKEREI ROSENAU'
            }
        ]

    })
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.page-section {
  padding: 1rem 0;
}
.pb-5,
.py-5 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.col-md-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}
.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
</style>